import React from "react";
import { Outlet } from "react-router-dom";
import Footer from '../Footer';
import NavbarCustom from "../NavbarCustom";


const Layout = () => {
  return (
    <div className="layout-wrapper">
      <NavbarCustom/>
      <div className="layout-content">
        <Outlet />
      </div>
      <Footer/>
    </div>
  );
};


export default Layout;
